export const NUMBER_OF_ITEMS_ON_DASHBOARD = 5
export const NUMBER_OF_ITEMS_ON_SEPARATE_PAGE = 10
export const REFETCH_INTERVAL = 5000
